
const FormattedJson = data => (
  <pre className="modal-pre-text">{JSON.stringify(data.data, null, 4)}</pre>
);

export default FormattedJson;
